import { Component, ViewChild } from '@angular/core';
import { DxDataGridModule, DxDataGridComponent, DxTemplateModule } from 'devextreme-angular';
import { CustomStore } from 'devextreme-angular/common/data';
import { lastValueFrom } from 'rxjs';
import { ApiService } from '../../services/api.service';
import { DecimalPipe, DatePipe } from '@angular/common';
import { HostDetailGridComponent } from '../../components/host-detail-grid/host-detail-grid.component';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-monitoring-overview',
  imports: [DxDataGridModule, DecimalPipe, DatePipe, DxTemplateModule, HostDetailGridComponent, CommonModule],
  templateUrl: './monitoring-overview.component.html',
  styleUrl: './monitoring-overview.component.css'
})
export class MonitoringOverviewComponent {
@ViewChild('dataGrid') dataGrid!: DxDataGridComponent;
  // "now" to track activity
  now: number = Date.now();
  private nowInterval: any;

  private startsWithUpdateCondition = "Starting Update...";
  private startsWithErrorCondition = "Failed to execute Update";

  dataStore: CustomStore;

  ngOnInit() {
    this.nowInterval = setInterval(() => {
      this.now = Date.now();
    }, 60000); // update every minute
  }

  constructor(private apiService: ApiService) {
    this.dataStore = this.apiService.historyStore;
  }

  ngOnDestroy() {
    if (this.nowInterval) {
      clearInterval(this.nowInterval);
    }
  }

  getClassForUpdateStatus(data: any): string {
    // data.value/ current_data_update is true when something occured (update or error)
    // kind of not enough for our use case...
    // no data found => no status to give
    if(!data.data.last_update)
      return "";

    if(this.isError(data.data.last_update_text))
      return "dx-icon-isnotblank update-red";
    else if(this.isUpdating(data.data.last_update_text))
      return "dx-icon-isnotblank update-green blink";
    else if(this.isOlderThanToday(data.data.last_update))
      return "dx-icon-isblank update-red";
    else if(!data.value) // no update or error, not older than today
      return "dx-icon-isnotblank update-green";
    else return ""; // this should not happen unless there is no data available
  }
  getTooltipForUpdateStatus(data: any): string {
    if(!data.data.last_update)
      return "";

    if(this.isError(data.data.last_update_text))
      return "Fehler bei der Aktualisierung" + (data.data.last_update_text ? `: ${data.data.last_update_text}` : '');
    else if(this.isUpdating(data.data.last_update_text))
      return "Aktualisierung läuft";
    else if(this.isOlderThanToday(data.data.last_update))
      return "Letzte Aktualisierung nicht mehr tagesaktuell";
    else if(!data.value) // no update or error, not older than today
      return "Aktualisierung tagesaktuell";
    else return ""; // this should not happen unless there is no data available
  }
  isOlderThanToday(date: Date): boolean {
    const yesterday = new Date();
    const dateToCheck = new Date(date);

    // Set to the start of the day 
    yesterday.setHours(0, 0, 0, 0); 
    dateToCheck.setHours(0, 0, 0, 0);

    yesterday.setDate(yesterday.getDate() - 1);
    return dateToCheck <= yesterday;
  }
  isUpdating(text: string): boolean {
    const txt = text;
    return txt?.startsWith(this.startsWithUpdateCondition) ?? false;
  }
  isError(text :string): boolean {
    const txt = text;
    return txt?.startsWith(this.startsWithErrorCondition) ?? false;
  }

}
